module.exports = __webpack_public_path__ + "media/images/fut-mobile-9d28173a6941bd2b8208bb340afd492b.jpg";